<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Mejores Rendimientos</template>
                    <template slot="en">Better Performance</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
        <div class="container">
            <p class="text text-primary">
                <text-lang :lang="lang">
                    <template slot="es">Nuestros criterios de inversión apuntan a altos rendimientos.</template>
                    <template slot="en">Our investment criteria is designed to yield higher returns.</template>
                </text-lang>
            </p>

            <box-container size="4">
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Invertimos en empresas de mayor crecimiento y que pueden trasladar la inflación a sus precios.</template>
                            <template slot="en">We directly invest in companies with a high potential for growth and development which are able to mitigate economic downturns.</template>
                        </text-lang>
                    </div>
                </box>
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Invertimos en empresas Empresas en industrias en crecimiento, que buscan capital para aumentar ventas y reducir costos sustancialmente.mayor crecimiento y que pueden trasladar la inflación a sus precios.</template>
                            <template slot="en">We seek and invest in companies in rapidly growing industries, looking for capital to increase sales and reduce costs significantly.</template>
                        </text-lang>
                    </div>
                </box>
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Aportamos dirección que permita optimizar procesos y reducir costos.</template>
                            <template slot="en">We provide management direction that allows companies to optimize precesses and reduce costs.</template>
                        </text-lang>
                    </div>
                </box>
                <box>
                    <div class="text text-tertiary">
                        <text-lang :lang="lang">
                            <template slot="es">Supervisamos la inversión hasta lograr los rendimientos esperados.</template>
                            <template slot="en">We diligently manage and supervise our investments until we yield the expected returns and achieve the expected growth.</template>
                        </text-lang>
                    </div>
                </box>
            </box-container> 
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import BoxContainer from '@/components/BoxContainer.vue'
import Box from '@/components/Box.vue'
import TextLang from '@/components/TextLang.vue'

export default {
    name: 'BetterPerformance',
    props: ['lang'],
    components: {
        Parallax,
        BoxContainer,
        Box,
        TextLang
    }
}
</script>
